import { centralSession } from './centralAuth'
import { clearSession, writeSession } from '@/helpers/storage'
import { publishSession } from '@/services/apiClient'

export async function selectBusiness(businessUserId: string) {
  const session = await centralSession(businessUserId)
  writeSession(session)
  publishSession(session)
  return session
}
export async function loadBusinesses() { return (await centralSession()).businesses }
export function signOut() { clearSession(); publishSession(null) }
